/*
 * STORE_INFO.WHATSAPP_NUMBER debe configurarse con el número real antes
 * de publicar el sitio (ver utils/constants).
 */
export function buildWhatsAppMessage(items) {
  const lines = items.map((item) => {
    const attributes = item.attributesLabel ? ` (${item.attributesLabel})` : "";

    return `• ${item.quantity}x ${item.name}${attributes}`;
  });

  return [
    "Hola, quisiera hacer este pedido:",
    "",
    ...lines,
    "",
    "¿Me confirman precio y disponibilidad?",
  ].join("\n");
}

export function buildWhatsAppUrl(whatsappNumber, message) {
  return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
}
